import { PricingEnum } from './constants';

export function getRankings(localStorageState) {
  const priceCategoryEntries = Object.entries(localStorageState.updatedPriceTracker);

  const bodyTypeCategoryEntries = Object.entries(localStorageState.updatedBodyTypeTracker);

  const rankedBodyTypes = bodyTypeCategoryEntries
    .sort((a, b) => b[1] - a[1])
    .map((item) => item[0])
    .filter((item) => item !== 'undefined');

  const rankedPriceRanges = priceCategoryEntries
    .sort((a, b) => b[1] - a[1])
    .map((item) => item)
    .filter((item) => item !== 'undefined');

  const priceCategoryValues = {
    [PricingEnum.ENTRY]: 0,
    [PricingEnum.MID]: 1,
    [PricingEnum.PREMIUM]: 2,
    [PricingEnum.LUXURY]: 3,
    [PricingEnum.SPORT]: 4,
  };

  let top3RankingScore = 0;

  const entriesWithUserValues = rankedPriceRanges.filter(([_, value]) => value !== 0);

  entriesWithUserValues.forEach((item) => {
    top3RankingScore += priceCategoryValues[item[0]];
  });

  const entriesWithZeroValue = rankedPriceRanges.filter(([_, value]) => value === 0);

  let sortedEntries;

  // we want a top 3 price range score
  // Entry = 0, Mid = 1, Premium = 2, Luxury = 3, Ultra Luxury = 4
  // if top 3 <= 2, stack luxury at the end
  // if top 3 >= 5, stack luxury at the beginning
  // if inbetween just push either entry or ultra luxury to the end
  const priorityMap = {
    [PricingEnum.ENTRY]: 0,
    [PricingEnum.MID]: 1,
    [PricingEnum.PREMIUM]: 2,
    [PricingEnum.LUXURY]: 3,
    [PricingEnum.SPORT]: 4,
  };

  /**
   * We need to re-rank price categories with no user interactions.
   * - ideally we create a score for the top 3 price rankings & make deducations on how the rest can be sorted
   * - there maybe only be 1 price category with user interactions, so need to assess top3RankingScore accordingly
   */
  if (entriesWithUserValues.length === 1) {
    if (top3RankingScore < 1) {
      sortedEntries = entriesWithZeroValue.sort((a, b) => {
        if (a[0] === PricingEnum.ENTRY) return -1;
        if (b[0] === PricingEnum.ENTRY) return 1;
        if (a[0] === PricingEnum.MID) return -1;
        if (b[0] === PricingEnum.MID) return 1;
        if (a[0] === PricingEnum.PREMIUM) return -1;
        if (b[0] === PricingEnum.PREMIUM) return 1;
        if (a[0] === PricingEnum.LUXURY) return -1;
        if (b[0] === PricingEnum.LUXURY) return 1;
        if (a[0] === PricingEnum.SPORT) return -1;
        if (b[0] === PricingEnum.SPORT) return 1;
        return priorityMap[a[0]] - priorityMap[b[0]];
      });
    } else if (top3RankingScore > 0 && top3RankingScore <= 2) {
      sortedEntries = entriesWithZeroValue.sort((a, b) => {
        if (a[0] === PricingEnum.MID) return -1;
        if (b[0] === PricingEnum.MID) return 1;
        if (a[0] === PricingEnum.PREMIUM) return -1;
        if (b[0] === PricingEnum.PREMIUM) return 1;
        if (a[0] === PricingEnum.ENTRY) return -1;
        if (b[0] === PricingEnum.ENTRY) return 1;
        if (a[0] === PricingEnum.PREMIUM) return -1;
        if (b[0] === PricingEnum.PREMIUM) return 1;
        if (a[0] === PricingEnum.SPORT) return -1;
        if (b[0] === PricingEnum.SPORT) return 1;
        return priorityMap[a[0]] - priorityMap[b[0]];
      });
    } else if (top3RankingScore >= 3) {
      sortedEntries = entriesWithZeroValue.sort((a, b) => {
        if (a[0] === PricingEnum.SPORT) return -1;
        if (b[0] === PricingEnum.SPORT) return 1;
        if (a[0] === PricingEnum.LUXURY) return -1;
        if (b[0] === PricingEnum.LUXURY) return 1;
        if (a[0] === PricingEnum.PREMIUM) return -1;
        if (b[0] === PricingEnum.PREMIUM) return 1;
        if (a[0] === PricingEnum.MID) return -1;
        if (b[0] === PricingEnum.MID) return 1;
        if (a[0] === PricingEnum.ENTRY) return -1;
        if (b[0] === PricingEnum.ENTRY) return 1;
        return priorityMap[a[0]] - priorityMap[b[0]];
      });
    }
  } else {
    if (top3RankingScore <= 1) {
      sortedEntries = entriesWithZeroValue.sort((a, b) => {
        if (a[0] === PricingEnum.ENTRY) return -1;
        if (b[0] === PricingEnum.ENTRY) return 1;
        if (a[0] === PricingEnum.MID) return -1;
        if (b[0] === PricingEnum.MID) return 1;
        if (a[0] === PricingEnum.PREMIUM) return -1;
        if (b[0] === PricingEnum.PREMIUM) return 1;
        if (a[0] === PricingEnum.LUXURY) return -1;
        if (b[0] === PricingEnum.LUXURY) return 1;
        if (a[0] === PricingEnum.SPORT) return -1;
        if (b[0] === PricingEnum.SPORT) return 1;
        return priorityMap[a[0]] - priorityMap[b[0]];
      });
    } else if (top3RankingScore > 1 && top3RankingScore < 5) {
      sortedEntries = entriesWithZeroValue.sort((a, b) => {
        if (a[0] === PricingEnum.MID) return -1;
        if (b[0] === PricingEnum.MID) return 1;
        if (a[0] === PricingEnum.PREMIUM) return -1;
        if (b[0] === PricingEnum.PREMIUM) return 1;
        if (a[0] === PricingEnum.ENTRY) return -1;
        if (b[0] === PricingEnum.ENTRY) return 1;
        if (a[0] === PricingEnum.PREMIUM) return -1;
        if (b[0] === PricingEnum.PREMIUM) return 1;
        if (a[0] === PricingEnum.SPORT) return -1;
        if (b[0] === PricingEnum.SPORT) return 1;
        return priorityMap[a[0]] - priorityMap[b[0]];
      });
    } else if (top3RankingScore >= 5) {
      sortedEntries = entriesWithZeroValue.sort((a, b) => {
        if (a[0] === PricingEnum.SPORT) return -1;
        if (b[0] === PricingEnum.SPORT) return 1;
        if (a[0] === PricingEnum.LUXURY) return -1;
        if (b[0] === PricingEnum.LUXURY) return 1;
        if (a[0] === PricingEnum.PREMIUM) return -1;
        if (b[0] === PricingEnum.PREMIUM) return 1;
        if (a[0] === PricingEnum.MID) return -1;
        if (b[0] === PricingEnum.MID) return 1;
        if (a[0] === PricingEnum.ENTRY) return -1;
        if (b[0] === PricingEnum.ENTRY) return 1;
        return priorityMap[a[0]] - priorityMap[b[0]];
      });
    }
  }

  const finalRankedPriceRanges = [...entriesWithUserValues, ...sortedEntries].map(
    ([key, _value]) => key,
  );

  return { rankedPriceRanges: finalRankedPriceRanges, rankedBodyTypes };
}
